import { useQuery } from '@tanstack/react-query';
import { getDataRoomAccess } from '@/api/data-room-access.api';
import { dataRoomAccessKeys } from './data-room-access.queries';

/**
 * A startup's data-room access: the open period with its seats, and its Issue
 * Report history (v1.2). Disabled until a startup id is known and the caller
 * may read it, so no request fires for a member the API would refuse.
 *
 * @param startupId - the startup entity, or null when there is none
 * @param enabled - false for a caller without `billing.manage`
 */
export function useDataRoomAccess(startupId: string | null, enabled = true) {
  return useQuery({
    queryKey: dataRoomAccessKeys.forStartup(startupId ?? ''),
    queryFn: () => getDataRoomAccess(startupId as string),
    enabled: Boolean(startupId) && enabled,
  });
}
